if ( $('body').hasClass('page-template-page-donate') ) {

        $('#contact-phone').mask('(000) 000-0000');
        $('#billing-phone').mask('(000) 000-0000');
        $('#cc-num').mask('0000000000000000');
        $('#cc-sec').mask('0000');

        function validateAddr(addr) {
            var re = /^[a-z\d\-.\s]+$/;
            return re.test(addr.toLowerCase());
        }

        function validateAmount(amount) {
            var re = /^[+-]?[0-9]{1,3}(?:,?[0-9]{3})*(?:\.[0-9]{2})?$/;
            return re.test(amount);
        }

        function validateEmail(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        }

        function validateZip(zip) {
            var re = /^[a-z\d\-\s]+$/;
            return re.test(zip.toLowerCase());
        }

        function validateName(name) {
            if (/[0-9]$/.exec(name)) {
                return true;
            }
            return false;
        }

        function add_alert(msg,type) {

            $('#alert').remove();
            $('#donate-form .header').after('<div id="alert" class="alert alert-' + type + '">' + msg + '</div>');
            window.location.hash= '#a';

        }

        $('#btn-submit').click(function(){

            $('#form-donate').submit();
            return false;

        });

        $('#form-donate').submit(function(){

            var $form = $(this);
            $form.find('#btn-submit').addClass('disabled').prop('disabled', true);

            window.location.hash= '';
            $('#alert').remove();

            var error = false;

            // check donation amt
            if( $('#donate-amt .btn').eq(3).hasClass('selected') === true ) {

                if ($('#donate-amt input').val() <= 0 || $('#donate-amt input').val() == '') {
                    add_alert('Please choose or enter the amount of your donation', 'warning');
                    $form.find('button').removeClass('disabled').prop('disabled', false);
                    return false;
                }
            }

            if ( $('#donate-amt .btn.selected').html() == 'Other' && !validateAmount( $('#field-amount').val() ) ) {
                add_alert('Please enter a valid amount. ','warning');
                $form.find('button').removeClass('disabled').prop('disabled', false);
                return false;
            }

            if( $('input[name=donation-use]:checked').length == 0 ) {
                add_alert('Please choose how you would like your donation to be used. ','warning');
                $form.find('button').removeClass('disabled').prop('disabled', false);
                return false;
            }


            var x = $('.field-fname input').val();

            if( x == '' ) {
                add_alert('Please enter your first name','warning');
                $form.find('button').removeClass('disabled').prop('disabled', false);
                return false;
            }

            if( validateName(x) ) {
                add_alert('Please enter a valid first name','warning');
                $form.find('button').removeClass('disabled').prop('disabled', false);
                return false;
            }

            x = $('.field-lname input').val();

            if( x == '' ) {
                add_alert('Please enter your last name','warning');
                $form.find('button').removeClass('disabled').prop('disabled', false);
                return false;
            }

            if( validateName(x) ) {
                add_alert('Please enter a valid last name','warning');
                $form.find('button').removeClass('disabled').prop('disabled', false);
                return false;
            }


            x = $('#contact-email').val();

            if( x == '' ) {
                add_alert('Please enter your email','warning');
                $form.find('button').removeClass('disabled').prop('disabled', false);
                return false;
            }

            if( !validateEmail(x) ) {
                add_alert('Please enter a valid email','warning');
                $form.find('button').removeClass('disabled').prop('disabled', false);
                return false;
            }

            x = $('.field-phone input').val();

            if( x == '' ) {
                add_alert('Please enter your phone number under donor information','warning');
                $form.find('button').removeClass('disabled').prop('disabled', false);
                return false;
            }

            if( x.length < 14) {
                add_alert('Please enter a valid phone number under donor information','warning');
                $form.find('button').removeClass('disabled').prop('disabled', false);
                return false;
            }

            if( $('#checkbox-more-names:checked').length > 0) {

                x = $('#contact2-fname').val();

                if( x == '' ) {
                    add_alert('Please enter a first name for your first additional donor','warning');
                    $form.find('button').removeClass('disabled').prop('disabled', false);
                    return false;
                }

                if( validateName(x) ) {
                    add_alert('Please enter a valid first name for your first additional donor','warning');
                    $form.find('button').removeClass('disabled').prop('disabled', false);
                    return false;
                }

                x = $('#contact2-lname').val();

                if( x == '' ) {
                    add_alert('Please enter a last name for your first additional donor','warning');
                    $form.find('button').removeClass('disabled').prop('disabled', false);
                    return false;
                }

                if( validateName(x) ) {
                    add_alert('Please enter a valid last name for your first additional donor','warning');
                    $form.find('button').removeClass('disabled').prop('disabled', false);
                    return false;
                }

                x = $('#contact3-fname').val();
                y = $('#contact3-lname').val();

                if(x != '' || y != '') {

                    if( x == '' ) {
                        add_alert('Please enter a first name for your second additional donor','warning');
                        $form.find('button').removeClass('disabled').prop('disabled', false);
                        return false;
                    }

                    if( validateName(x) ) {
                        add_alert('Please enter a valid first name for your second additional donor','warning');
                        $form.find('button').removeClass('disabled').prop('disabled', false);
                        return false;
                    }

                    if( y == '' ) {
                        add_alert('Please enter a last name for your second additional donor','warning');
                        $form.find('button').removeClass('disabled').prop('disabled', false);
                        return false;
                    }

                    if( validateName(y) ) {
                        add_alert('Please enter a valid last name for your second additional donor','warning');
                        $form.find('button').removeClass('disabled').prop('disabled', false);
                        return false;
                    }
                }

            }

            x = $('#cc-name').val();

            if( x == '' ) {
                add_alert('Please enter the name on your credit card','warning');
                $form.find('button').removeClass('disabled').prop('disabled', false);
                return false;
            }

            if( validateName(x) ) {
                add_alert('Please enter a valid cardholder name','warning');
                $form.find('button').removeClass('disabled').prop('disabled', false);
                return false;
            }

            if( $('.field-cc-type select').val() == '' ) {
                add_alert('Please select your credit card type','warning');
                $form.find('button').removeClass('disabled').prop('disabled', false);
                return false;
            }

            if( $('.field-cc-type select').val() == '' ) {
                add_alert('Please select your credit card type','warning');
                $form.find('button').removeClass('disabled').prop('disabled', false);
                return false;
            }

            if( $('#cc-num').val() == '' ) {
                add_alert('Please enter your credit card number','warning');
                $form.find('button').removeClass('disabled').prop('disabled', false);
                return false;
            }

            if( $('#cc-sec').val() == '' ) {
                add_alert('Please enter your credit card security code','warning');
                $form.find('button').removeClass('disabled').prop('disabled', false);
                return false;
            }

            if( $('#cc-sec').val().length > 4 ||  $('#cc-sec').val().length < 3 ) {
                add_alert('Please a valid security code for your credit card','warning');
                $form.find('button').removeClass('disabled').prop('disabled', false);
                return false;
            }

            if( $('.field-cc-expire select').eq(0).val() == 0 || $('.field-cc-expire select').eq(1).val() == 0 ) {
                add_alert('Please enter your credit card\'s expire date','warning');
                $form.find('button').removeClass('disabled').prop('disabled', false);
                return false;
            }

            x = $('#billing-phone').val();

            if( x == '' ) {
                add_alert('Please enter your phone number under billing information','warning');
                $form.find('button').removeClass('disabled').prop('disabled', false);
                return false;
            }

            if( x.length < 14) {
                add_alert('Please enter a valid phone number under billing information','warning');
                $form.find('button').removeClass('disabled').prop('disabled', false);
                return false;
            }

            if( $('#billing-street').val() == '' ) {
                add_alert('Please enter your street address under billing information','warning');
                $form.find('button').removeClass('disabled').prop('disabled', false);
                return false;
            }

            if( !validateAddr( $('#billing-street').val() ) ) {
                add_alert('Please enter a valid street address','warning');
                $form.find('button').removeClass('disabled').prop('disabled', false);
                return false;
            }

            if( $('#billing-street2').val() != '' ) {
                if( !validateAddr( $('#billing-street2').val() ) ) {
                    add_alert('Please enter a valid street address','warning');
                    $form.find('button').removeClass('disabled').prop('disabled', false);
                    return false;
                }
            }

            x = $('#billing-city').val();

            if( x == '' ) {
                add_alert('Please enter the city of your billing address','warning');
                $form.find('button').removeClass('disabled').prop('disabled', false);
                return false;
            }

            if( validateName(x) ) {
                add_alert('Please enter a valid city under billing address','warning');
                $form.find('button').removeClass('disabled').prop('disabled', false);
                return false;
            }

            if( $('#billing-state').val() == '' ) {
                add_alert('Please enter your state/province under billing information','warning');
                $form.find('button').removeClass('disabled').prop('disabled', false);
                return false;
            }

            x = $('#billing-zip').val();

            if( x == '' ) {
                add_alert('Please enter your zip/postal code under billing information','warning');
                $form.find('button').removeClass('disabled').prop('disabled', false);
                return false;
            }

            if( !validateZip(x) ) {
                add_alert('Please enter a valid zip/postal code under billing information','warning');
                $form.find('button').removeClass('disabled').prop('disabled', false);
                return false;
            }

            if( $('#billing-country').val() == 0 ) {
                add_alert('Please enter your country under billing information','warning');
                $form.find('button').removeClass('disabled').prop('disabled', false);
                return false;
            }

            if( $('#send-message:checked').length > 0 ) {

                if( $('#dedication').val() == '' ) {
                    add_alert('Please enter the name of the person or organization you are dedicating your donation to','warning');
                    $form.find('button').removeClass('disabled').prop('disabled', false);
                    return false;
                }

                if( $('#dedication-message').val() == '' ) {
                    add_alert('Please enter a message for the person or organization you are dedicating your donation to','warning');
                    $form.find('button').removeClass('disabled').prop('disabled', false);
                    return false;
                }

                switch( $('input[name=ack-type]:checked').val() ) {

                 case 'email':
                 x = $('#email-to').val();
                 if( x == '' ) {
                     add_alert('Please enter the email of the individual or organization to whom you are dedicating your donation.','warning');
                     $form.find('button').removeClass('disabled').prop('disabled', false);
                     return false;
                 }
                 if( !validateEmail(x) ) {
                     add_alert('Please enter a valid email for the individual or organization to whom you are dedicating your donation.','warning');
                     $form.find('button').removeClass('disabled').prop('disabled', false);
                     return false;
                 }
                 break;
                 case 'postal':
                 if( $('#street-to').val() == '' ) {
                     add_alert('Please enter a street address under dedication information','warning');
                     $form.find('button').removeClass('disabled').prop('disabled', false);
                     return false;
                 }

                 if( !validateAddr( $('#street-to').val() ) ) {
                     add_alert('Please enter a valid street address under dedication information','warning');
                     $form.find('button').removeClass('disabled').prop('disabled', false);
                     return false;
                 }

                 if( $('#street2-to').val() != '' ) {
                     if( !validateAddr( $('#street2-to').val() ) ) {
                         add_alert('Please enter a valid street address under dedication information','warning');
                         $form.find('button').removeClass('disabled').prop('disabled', false);
                         return false;
                     }
                 }

                 x = $('#city-to').val();

                 if( x == '' ) {
                     add_alert('Please enter the city of your dedication address','warning');
                     $form.find('button').removeClass('disabled').prop('disabled', false);
                     return false;
                 }

                 if( validateName(x) ) {
                     add_alert('Please enter a valid city under dedication address','warning');
                     $form.find('button').removeClass('disabled').prop('disabled', false);
                     return false;
                 }

                 if( $('#state-to').val() == '' ) {
                     add_alert('Please enter your state/province under dedication information','warning');
                     $form.find('button').removeClass('disabled').prop('disabled', false);
                     return false;
                 }

                 x = $('#zip-to').val();

                 if( x == '' ) {
                     add_alert('Please enter your zip/postal code under dedication information','warning');
                     $form.find('button').removeClass('disabled').prop('disabled', false);
                     return false;
                 }

                 if( !validateZip(x) ) {
                     add_alert('Please enter a valid zip/postal code under dedication information','warning');
                     $form.find('button').removeClass('disabled').prop('disabled', false);
                     return false;
                 }

                 if( $('#country-to').val() == 0 ) {
                     add_alert('Please enter your country under dedication information','warning');
                     $form.find('button').removeClass('disabled').prop('disabled', false);
                     return false;
                 }
                 break;
                 default:
                 add_alert('Please choose how you would like to send your acknowledgement.','warning');
                 $form.find('button').removeClass('disabled').prop('disabled', false);
                 return false;
             }

         }

            //payeezy
            var responseHandler = function(status, response) {
                var $form = $('#form-donate');

                if (status != 201) {

                    if (response.error && status != 400) {
                        var error = response["error"];
                        var errormsg = error["messages"];
                        var errorcode = JSON.stringify(errormsg[0].code, null, 4);
                        var errorMessages = JSON.stringify(errormsg[0].description, null, 4);

                        add_alert(errorMessages,'warning');

                        $form.find('button').removeClass('disabled').prop('disabled', false);
                        return false;
                    } else if (status == 400 || status == 500) {

                        var errormsg = response.Error.messages;
                        var errorMessages = "";
                        for(var i in errormsg){

                            add_alert(errormsg[i].description,'warning');
                            return false;

                        }
                    } else {
                        add_alert('Your payment could not be processed at this time. Please <a href="/contact-us/">contact us</a> for more information.','warning');
                        return false;
                    }

                } else {

                    $form.find('button').addClass('disabled').prop('disabled', true);

                    jQuery.post(
                        ajaxurl,
                        {
                            'action': 'processTransaction',
                            'match': $('#donation-match').val(),
                            'amount': parseFloat($('#donation-amount').val()) * 100,
                            'use': $('input[name=donation-use]:checked').val(),
                            'comments': $('#donation-comments').val(),
                            'alumni':$('input[name=alumni]:checked').val(),
                            'memory': $('#alumni-memory').val(),
                            'contact_first_name': $('#contact-fname').val(),
                            'contact_last_name': $('#contact-lname').val(),
                            'contact_email': $('#contact-email').val(),
                            'input_9': $('#contact-email').val(), // For confirmation emails
                            'contact_phone': $('#contact-phone').val(),
                            'contact_phone_type':$('input[name=phone-1]:checked').val(),
                            'contact_display_name' : $('#contact-display-name').val(),
                            'anonymous': $('#anonymous').attr('checked') == 'checked' ? 'yes' : 'no',
                            'addition1-fname': $('#contact2-fname').val(),
                            'addition1-lname': $('#contact2-lname').val(),
                            'addition2-fname': $('#contact3-fname').val(),
                            'addition2-lname': $('#contact3-lname').val(),
                            'subscribe': $('#subscribe').attr('checked') == 'checked' ? 'yes' : 'no',
                            'token-name': response.token.cardholder_name,
                            'token-type': response.token.type,
                            'token-value': response.token.value,
                            'token-exp': response.token.exp_date,
                            'billing-phone': $('#billing-phone').val(),
                            'billing_phone_type':$('input[name=phone-2]:checked').val(),
                            'billing-street': $('#billing-street').val(),
                            'billing-street2': $('#billing-street2').val(),
                            'billing-city': $('#billing-city').val(),
                            'billing-state': $('#billing-state').val(),
                            'billing-zip': $('#billing-zip').val(),
                            'billing-country': $('#billing-country').val(),
                            'dedication': $('#dedication').val(),
                            'dedication-message': $('#dedication-message').val(),
                            'send-message': $('#send-message').val(),
                            'recipient-name': $('#name-to').val(),
                            'recipient-email': $('#email-to').val(),
                            'input_20': $('#email-to').val(), // For confirmation emails
                            'recipient-street': $('#street-to').val(),
                            'recipient-street2': $('#street2-to').val(),
                            'recipient-street2': $('#street2-to').val(),
                            'recipient-city': $('#city-to').val(),
                            'recipient-state': $('#state-to').val(),
                            'recipient-zip': $('#zip-to').val(),
                            'recipient-country': $('#country-to').val(),
                        },
                        function(response){

                            $form.find('button').removeClass('disabled').prop('disabled', false);

                            if(response != 'success') {
                                add_alert('Your payment could not be processed at this time. Please <a href="/contact-us/">contact us</a> for more information. <br><b>Error code: ' + response + '</b>','warning');
                                return false;
                            }

                            $('#donate-form').html('<h4>Thank You!</h4><p style="font-size:24px;">Your donation has been received and will help change lives.</p>');
                            return false;
                        }
                        );

                }

            };

            Payeezy.setApiKey('avoU0EhfIgJP92w7wQi0cDYUVFd8qTTD');
            // Payeezy.setJs_Security_Key('js-915e45133d072af7238016944546431f915e45133d072af7'); // sandbox
            Payeezy.setJs_Security_Key('js-e01ad56de66b7c62d6ce209e3e626291e01ad56de66b7c62'); // prod
            //Payeezy.setTa_token('NOIW'); // sandbox
            Payeezy.setTa_token('EEH1');
            Payeezy.setAuth('false');
            Payeezy.createToken(responseHandler);

            $form.find('button').removeClass('disabled').prop('disabled', false);
            return false;

        });

    $('#donate-amt .btn').click(function(){
        $(this).parent().find('.btn').removeClass('selected');
        $(this).addClass('selected');
        if( !$('#donate-amt .btn').eq(3).hasClass('selected') ) {
            $('#field-amount').val(null);
        }
        return false;
    });

    $('#field-amount').focus(function(){
        $(this).parent().find('.btn').removeClass('selected');
        $(this).parent().find('.btn').eq(3).addClass('selected');
        $('#donation-amount').val( $('#field-amount').val() );
    });

    $('#donate-amt .btn').click(function(){

        var x = $('#donate-amt .btn.selected').html().replace('$','');

        if(x == 'Other') {
            x = $('#field-amount').val();
        }

        $('#donation-amount').val(x);

    });

    $('#field-amount').on('change input', function(event){

        $(this).val($(this).val().replace(/[^0-9\.]/g,''));

        if ( (event.which != 46 || $(this).val().indexOf('.') != -1) && (event.which < 48 || event.which > 57) ) {
            event.preventDefault();
        }

        $('#donation-amount').val( $(this).val() );

    });

    $('input[name=cc-type]').change(function(){

        $('.field-cc-type select').val( $(this).val() );

    });

    $('input[name=phone-2]').change(function(){

        $('.fieldgroup-billing .field-phone input[type=hidden]').val( $(this).val() );

    });

    $('.fieldgroup-billing .field-country select').change(function(){

        switch( $(this).val() ) {
            case 'US':
            $('#input-state-text').hide();
            $('#input-state-select').show();
            break;
            default:
            $('#input-state-text').show();
            $('#input-state-select').hide();
        }

    });

    $('#input-state-select, #input-state-text').change(function(){

        $('.fieldgroup-billing .field-state-zip input[type=hidden]').val( $(this).val() );

    });

    $('.fieldgroup-special .checkbox input').change(function(){

        switch( $(this).attr('checked') ) {
            case 'checked':
            $('.expand').fadeIn();
            break;
            default:
            $('.expand').fadeOut();
        }

    });

    $('#checkbox-more-names').change(function(){

        $('.more-names').toggle();

    });

    $('input[name=ack-type]').change(function(){

        switch( $(this).val() ) {
            case 'email':
            $('.radios .field-email').show();
            $('.radios .fieldgroup-addr').hide();
            break;
            case 'postal':
            $('.radios .field-email').hide();
            $('.radios .fieldgroup-addr').show();
            break;
        }

    });

    $('#input-state-select2').change(function(){

        $('#state-to').val( $(this).val() );

    });

    $('input[name="dedication-radio"]:radio').on('change', function () {
        var option = $('input[name="dedication-radio"]:checked').val(),
            dedicationContainer = $('#donation-dedication-container'),
            dedication = $('#dedication'),
            dedicationMessage = $('#dedication-message');

        console.log(option);

        if ( option == 'none' ) {
            dedicationContainer.fadeOut('fast', function () {
                dedication.val('');
                dedicationMessage.val('');
            });
        } else if ( option == 'honor' ) {
            dedication.siblings('label').text('Please accept my donation in honor of: ');
            dedicationContainer.fadeIn('fast', function () {
                dedication.val('');
                dedicationMessage.val('In honor of ');
            });
        } else if ( option == 'memory' ) {
            dedication.siblings('label').text('Please accept my donation in memory of: ');
            dedicationContainer.fadeIn('fast', function () {
                dedication.val('');
                dedicationMessage.val('In memory of ');
            });
        }
    });

} // end if donate page